const IprIcon = (props) => {
  const position =
    props.position === undefined || props.position === null
      ? "unset"
      : props.position
  const left =
    props.left === undefined || props.left === null ? "unset" : props.left - 1
  const top =
    props.top === undefined || props.top === null ? "unset" : props.top

  return props.direction === "up" ? (
    <div
      style={{
        width: "2px",
        height: "33px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: position,
        left: left,
        top: top,
        visibility: props.visibility,
        // background: "#02AFEC",
      }}
    >
      <div
        style={{
          width: "6px",
          height: "6px",
          borderTop: "6px solid #02AFEC",
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
        }}
      />

      <div
        style={{
          width: "2px",
          height: "27px",
          background: "#02AFEC",
        }}
      />
    </div>
  ) : (
    <div
      style={{
        width: "2px",
        height: "33px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: position,
        left: left,
        top: top,
        visibility: props.visibility,
        // background: "#02AFEC",
      }}
    >
      <div
        style={{
          width: "2px",
          height: "27px",
          background: "#02AFEC",
        }}
      />
      <div
        style={{
          width: "6px",
          height: "6px",
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
          borderBottom: "6px solid #02AFEC",
        }}
      />
    </div>
  )
}

export default IprIcon
